export { default as ArtifactSingular } from './ArtifactSingular';